import React from 'react';
import PropTypes from 'prop-types';
import { CustomLabel6 } from '@4beefopag/4bee-fopag-core/dist/atoms';
import styled from 'styled-components';
import { ArrowVertical, ArrowDown, ArrowUp } from '../../../../assets';
import Header from '../Header';

const CustomLabel = styled(CustomLabel6)`
  cursor: pointer;
`;

function HeaderWithSort({ label, width, orderType, clickOnOrder, left, fixed }) {
  const selectIcon = () => {
    if (orderType === 'asc') {
      return ArrowDown;
    }
    if (orderType === 'desc') {
      return ArrowUp;
    }
    return ArrowVertical;
  };

  const clickOrderButton = () => {
    if (orderType === 'asc') {
      clickOnOrder('desc');
    } else {
      clickOnOrder('asc');
    }
  };

  return (
    <Header
      onClick={clickOrderButton}
      width={width}
      left={left}
      fixed={fixed}
    >
      <CustomLabel>
        {label}{' '}
        <img
          alt={label}
          src={selectIcon()}
        />{' '}
      </CustomLabel>
    </Header>
  );
}
HeaderWithSort.propTypes = {
  label: PropTypes.string.isRequired,
  orderType: PropTypes.oneOf(['asc', 'desc']),
  width: PropTypes.number,
  left: PropTypes.number,
  clickOnOrder: PropTypes.func,
  fixed: PropTypes.bool,
};

HeaderWithSort.defaultProps = {
  orderType: undefined,
  width: undefined,
  left: undefined,
  clickOnOrder: () => undefined,
  fixed: false,
};

export default HeaderWithSort;
